import * as React from 'react';
import * as _ from 'underscore';

import { imgUrl } from '../../utilities/ImgUrl';
import { CommonStyles } from '../CommonStyles';
import { IReactTranslateService } from '../IReactTranslateService';

export class SearchBox extends React.Component<SearchBox.Props, any> {

  public static displayName = 'SearchBox';

  public static element = React.createFactory(SearchBox);

  public render() {

    const inputProps = _.extend({},
      {
        placeholder: this.props.translate ? this.props.translate('search') : '',
        className: 'tb-placeholder',
        'data-tb-test-id': 'search-box-input'
      },
      this.props.inputProps);

    inputProps.style = _.extend({},
      {
        fontWeight: 'normal',
        fontSize: CommonStyles.Sizes.NormalFontSize,

        height: CommonStyles.Sizes.RowHeight,

        paddingTop: CommonStyles.Sizes.TextBoxPadding,
        paddingBottom: CommonStyles.Sizes.TextBoxPadding,
        paddingLeft: CommonStyles.Sizes.TextBoxPadding + CommonStyles.Sizes.SmallIconSize,

        borderWidth: CommonStyles.Sizes.TextBoxBorderSize,
        borderColor: CommonStyles.Colors.BorderColor,
        borderStyle: 'solid',

        boxSizing: 'border-box',
        background: imgUrl('magnifying_glass_small_normal.svg')+' 0 center no-repeat',
        backgroundSize: CommonStyles.Sizes.NormalIconBackgroundSize,

        outline: 'none'
      },
      this.props.inputProps.style);

    return React.createElement('input',  inputProps);
  }

}

export module SearchBox {

  export interface Props {
    inputProps: React.HTMLProps<HTMLElement>;
    translate?: IReactTranslateService;
  }

}
